'use strict';

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '');
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/axios/lib/helpers/combineURLs.js
 ** module id = 108
 ** module chunks = 0
 **/